<template>
  <div class="flex justify-center rounded-lg mx-2 mt-12">
    <div class="">
      <div
        class="container mx-auto px-4 p-1 bg-basic-dark shadow-md drop-shadow-2xl lg:p-2 rounded-md place-items-center"
      >
        <div class="flex justify-center">
          <div v-if="isProcessing">
            <div class="z-50 flex justify-center items-center">
              <div
                class="animate-spin rounded-full md:h-32 md:w-32 h-24 w-24 border-t-2 border-b-2 border-gray-100"
              ></div>
            </div>
          </div>
        </div>
        <div class="mt-2">
          <p class="text-md text-white text-center">الرجاء الانتظار</p>
          <div class="border border-b-2 border-color mx-auto mt-1 w-36"></div>

          <div class="m-3 relative md:w-96 mx-auto" dir="rtl"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ISACTIVE } from "@/constants";
import { useAuthStore } from "@/stores/auth";
import { mapActions } from "pinia";
import { useToast } from "vue-toastification";

export default {
  components: {},

  data() {
    return {
      isProcessing: true,
      toast: useToast(),
    };
  },
  computed: {},

  methods: {
    ...mapActions(useAuthStore, ["callStatusAPI","setUserData"]),
    async handleStcPaymentStatus() {
      const urlParams = new URLSearchParams(window.location.search);
      const status = urlParams.get('Status');
        const queryParams = {
            msisdn: urlParams.get('MSISDN'),
            antiFraudUniqid: localStorage.getItem("AntiFrauduniqid"),
            channelId: urlParams.get('ChannelID'),
            clickId: urlParams.get('ClickID'),
            reason: urlParams.get('Reason'),
          };
      if (status === 'Success') {
        try {

          // If status is 'Success', call the status API and extract all the params to send them in the post request
        
          const response = await this.callStatusAPI(queryParams);
          console.log("Response from status API:", response.data);  
          // Stop processing to prevent multiple messages
          this.isProcessing = false;
          
          if (response.data.success) {
            await this.setUserData(response);
            setTimeout(() => {
              this.toast.success("تم الاشتراك بنجاح! مرحباً بك في ناسنا");
              this.$router.push({ name: "home" });
            }, 1000);
          } else {
            setTimeout(() => {
              this.toast.error("فشل في التحقق من حالة الاشتراك");
              this.$router.push({ name: "auth.subscribe" });
            }, 1000);
          }
        } catch (error) {
          console.error("Error calling status API:", error);
          this.isProcessing = false;
          setTimeout(() => {
            this.toast.error("حدث خطأ في النظام، يرجى المحاولة مرة أخرى");
            this.$router.push({ name: "auth.subscribe" });
          }, 1000);
        }
        return; // Exit early to prevent further execution
        // 
      } 
      
      if (status === 'Failure') {
        // Failure case - only show toast message
        this.isProcessing = false;
        this.toast.error(queryParams.reason || "فشل في عملية الدفع، يرجى المحاولة مرة أخرى");
        setTimeout(() => {
          this.$router.push({ name: "auth.subscribe" });
        }, 1000);
        return; // Exit early to prevent further execution
      }
      
      // No status parameter or unknown status - fallback to old logic
      await this.redirection();
    },

    async redirection() {
      const isActive = localStorage.getItem(ISACTIVE);
      if (isActive) {
        setTimeout(() => {
          this.$router.push({ name: "home" });
        }, 6000);
      } else {
        await this.$router.push({ name: "auth.subscribe" });
      }
    },
  },
  async created() {
    await this.handleStcPaymentStatus();
  },
};
</script>

<style scoped>
.w-btn {
  width: 290px;
  align-self: right;
}

.btn-color {
  background-color: #9d2890;
}

.bg-basic {
  background-color: #181b30;
}
</style>
